import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Dialog } from "primereact/dialog";

import CopyToClipboard from "./CopyToClipboard";

import "../index.css"
import { fetchAdjustmentReasons } from "../services/redux/reducers/commonThunk";
import { DATE_FORMAT } from "../constants";

const ViewAdjustmentNote = (props) => {
    const { type, adjustmentNote, materialDetails, buyerInvoiceItems, sellerPIPunchItems, visibleViewAdjustmentNote, setVisibleViewAdjustmentNote } = props

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const adjustmentReasons = useSelector(state => state.common.adjustmentReasons)

    useEffect(() => {
        dispatch(fetchAdjustmentReasons())
    }, [])
    
    let header = ""
    if (type === "Credit Note"){
        if (adjustmentNote[0]?.adjustmentTypeId === 1){
            header = "Credit Note"
        }else{
            header = "Debit Note"
        }
    }else{
        header = "Debit Note"
    }

    const handleDocClick = (adjustmentNote) => {
        if (adjustmentNote?.adjustmentTypeId === 1){
            navigate(`/credit_note/${adjustmentNote?.adjustmentNoteId}`)
        }else if ([3, 9, 10].includes(adjustmentNote?.adjustmentTypeId)){
            navigate(`/debitnote/${adjustmentNote?.adjustmentNoteId}`)
        }else {
            navigate(`/buyer-debit-note/${adjustmentNote?.adjustmentNoteId}`)
        }
    }

    return(
        <Dialog header={`View ${header}`} className='' visible={visibleViewAdjustmentNote} style={{ width: '55vw', minHeight: '30vh', backgroundColor: '#f8f8f8' }} onHide={() => setVisibleViewAdjustmentNote(false)}>
            <div className="view-debit-note-modal">
                {
                    type === 'Credit Note' ? (
                        adjustmentNote?.map((eachCreditNote) => {
                            let status = ""
                           
                            if (eachCreditNote?.statusId === 1){
                                status = "Approved"
                            }
                            if (eachCreditNote?.statusId === 7){
                                status = "Pending"
                            }

                            let remarks = ""

                            let relatedAdjustmentNoteReason = adjustmentReasons.find(eachAdjustmentReason => eachAdjustmentReason.adjustmentReasonId === eachCreditNote.adjustmentReasonId)
                
                            let adjustmentNoteReasonRemarks = relatedAdjustmentNoteReason ? `Reason: ${relatedAdjustmentNoteReason.adjustmentReasonName} ` : ""
                            if (eachCreditNote.returnToSeller){
                                adjustmentNoteReasonRemarks += `(Return To Seller)`
                            }
                
                            remarks = `${adjustmentNoteReasonRemarks} \n` + remarks 
                                
                            return (
                            <div key={`creditNote-${eachCreditNote.adjustmentNoteId}`} className={`p-card py-2 ${eachCreditNote?.statusId === 6 ? 'cancelled-watermark' : ''}`}>
                                <div className="flex flex-row justify-content-between">
                                    <div className='req-no-container' style={{ position: "relative" }}>
                                        <div className="flex flex-row">
                                            <p className='doc-no' style={{ cursor: "pointer" }} onClick={() => handleDocClick(eachCreditNote)}>
                                                {eachCreditNote.docNo ? eachCreditNote.docNo : "preview"}
                                            </p>
                                            <CopyToClipboard text={eachCreditNote.docNo} />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-xs m-0">{remarks}</p>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-xs m-0">{status}</p>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-xs m-0">{moment(eachCreditNote.createdAt).format(DATE_FORMAT)}</p>
                                    </div>
                                </div>
                                <div className="custom-table-container">
                                    <table className="custom-product-table mt-3" style={{ width: "100%" }}>
                                        <thead>
                                            <tr className="">
                                                <th className="" style={{ width: "50px" }}>SR</th>
                                                <th className="" style={{ width: "200px" }}>PRODUCT</th>
                                                <th className="" style={{ width: "350px" }}>SPECIFICATION</th>
                                                <th className="" style={{ width: "150px" }}>QUANTITY</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                            {
                                                eachCreditNote?.adjustmentNoteItems?.map((eachAdjustmentNoteItem, index) => {
                                                    const relatedBuyerInvoiceItem = buyerInvoiceItems?.find(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerInvoiceItemId === eachAdjustmentNoteItem?.buyerInvoiceItemId)
                                                    const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === relatedBuyerInvoiceItem?.materialId)
                                                    return (
                                                        <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                            <td className="" >{index + 1}</td>
                                                            <td className="" >{relatedMaterial?.productName}</td>
                                                            <td className="" >{relatedMaterial?.productSpecification}</td>
                                                            <td className="" >{eachAdjustmentNoteItem?.adjustedQty}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )})
                    ) : (
                        adjustmentNote?.map((eachCreditNote) => {
                            let status = ""
                            if (eachCreditNote?.statusId === 1){
                                status = "Approved"
                            }
                            if (eachCreditNote?.statusId === 7){
                                status = "Pending"
                            }
                            return (
                            <div key={`creditNote-${eachCreditNote.adjustmentNoteId}`} className={`p-card py-2 ${eachCreditNote?.statusId === 6 ? 'cancelled-watermark' : ''}`}>
                                <div className="flex flex-row justify-content-between">
                                    <div className='req-no-container' style={{ position: "relative" }}>
                                        <div className="flex flex-row">
                                            <p className='doc-no' style={{ cursor: "pointer" }} onClick={() => handleDocClick(eachCreditNote)}>
                                                {eachCreditNote.docNo}
                                            </p>
                                            <CopyToClipboard text={eachCreditNote.docNo} />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-xs m-0">{status}</p>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-xs m-0">{moment(eachCreditNote.createdAt).format(DATE_FORMAT)}</p>
                                    </div>
                                </div>
                                <div className="custom-table-container">
                                    <table className="custom-product-table mt-3" style={{ width: "100%" }}>
                                        <thead>
                                            <tr className="">
                                                <th className="" style={{ width: "50px" }}>SR</th>
                                                <th className="" style={{ width: "200px" }}>PRODUCT</th>
                                                <th className="" style={{ width: "350px" }}>SPECIFICATION</th>
                                                <th className="" style={{ width: "150px" }}>QUANTITY</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                            {
                                                eachCreditNote?.adjustmentNoteItems?.map((eachAdjustmentNoteItem, index) => {
                                                    const relatedSellerPIPunchItem = sellerPIPunchItems?.find(eachSellerPIPunchItem => eachSellerPIPunchItem?.sellerPIPunchItemId === eachAdjustmentNoteItem?.sellerPIPunchItemId)
                                                    const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === relatedSellerPIPunchItem?.materialId)
                                                    return (
                                                        <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                            <td className="" >{index + 1}</td>
                                                            <td className="" >{relatedMaterial?.productName}</td>
                                                            <td className="" >{relatedMaterial?.productSpecification}</td>
                                                            <td className="" >{eachAdjustmentNoteItem?.adjustedQty}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )})
                    )
                }
            </div>
        </Dialog>
    )
}

export default ViewAdjustmentNote;